import { Button, Paper } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import * as Color from "@material-ui/core/colors";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { MuiThemeProvider, withStyles } from "@material-ui/core/styles";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import React from "react";
import { lazy, Suspense} from "react";
import { withNamespaces } from "react-i18next";
import { Document, Page, pdfjs } from "react-pdf";
import { connect } from "react-redux";
import { Route, withRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "rsuite/dist/styles/rsuite-default.css";

import { refreshToken } from "./actions/auth";
import { axiosGet, axiosPost } from "./axios";


import { API_BASE_URL } from "./config";
import { ImagePath } from "./templates/style";

import HeaderBar from "./components/HeaderBar";

/**Components lazy import */
const Menu = lazy(() => import("./components/MenuPage"));
const Dashboard = lazy(() => import("./components/Dashboard"));
const DataManager = lazy(() => import("./components/DataManagerPage"));
const HammeringDetail = lazy(() => import("./components/details/HammeringDetail"));
const LotDetail = lazy(() => import("./components/details/LotDetail"));
const LofOfSaleDetail = lazy(() => import("./components/details/LotOfSaleDetail"));
const MeasurementDetail = lazy(() => import("./components/details/MeasurementDetail"));
const ExportPage = lazy(() => import("./components/ExportPage"));
const Login = lazy(() => import("./components/forms/LoginForm"));
const Printing = lazy(() => import("./components/forms/PartnerForm"));
const RegistrationPage = lazy(() => import("./components/forms/RegistrationPage"));
const LotsMap = lazy(() => import("./components/map/LotsMap"));
const Parameters = lazy(() => import("./components/Parameters"));
const HammeringPrint = lazy(() => import("./components/print/HammeringPrint"));
const LotPrint = lazy(() => import("./components/print/LotPrint"));
const PublicLotPrint = lazy(() => import("./components/print/PublicLotPrint"));
const MeasurementEssencePrint = lazy(() => import("./components/print/MeasurementEssencePrint"));
const MeasurementUtilisationPrint = lazy(() => import("./components/print/MeasurementUtilisationPrint"));
const PublicDataPage = lazy(() => import("./components/PublicDataPage"));
const CompanyTable  = lazy(() => import("./components/tables/CompanyTable"));
const Hammering = lazy(() => import("./components/tables/HammeringTable"));
const Lot = lazy(() => import("./components/tables/LotTable"));
const MeasurementTable = lazy(() => import("./components/tables/MeasurementTable"));

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${
  pdfjs.version
}/pdf.worker.js`;

console.log("%c\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2557   \u2588\u2588\u2557\u2588\u2588\u2557    \u2588\u2588\u2557   \u2588\u2588\u2557 \u2588\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2557   \u2588\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u000A\u2588\u2588\u2554\u2550\u2550\u2550\u2550\u255D\u255A\u2588\u2588\u2557 \u2588\u2588\u2554\u255D\u2588\u2588\u2551    \u2588\u2588\u2551   \u2588\u2588\u2551\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2557\u2588\u2588\u2588\u2588\u2557 \u2588\u2588\u2588\u2588\u2551\u2588\u2588\u2554\u2550\u2550\u2550\u2550\u255D\u255A\u2550\u2550\u2588\u2588\u2554\u2550\u2550\u255D\u000A\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557 \u255A\u2588\u2588\u2588\u2588\u2554\u255D \u2588\u2588\u2551    \u2588\u2588\u2551   \u2588\u2588\u2551\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2551\u2588\u2588\u2554\u2588\u2588\u2588\u2588\u2554\u2588\u2588\u2551\u2588\u2588\u2588\u2588\u2588\u2557     \u2588\u2588\u2551   \u000A\u255A\u2550\u2550\u2550\u2550\u2588\u2588\u2551  \u255A\u2588\u2588\u2554\u255D  \u2588\u2588\u2551    \u255A\u2588\u2588\u2557 \u2588\u2588\u2554\u255D\u2588\u2588\u2554\u2550\u2550\u2588\u2588\u2551\u2588\u2588\u2551\u255A\u2588\u2588\u2554\u255D\u2588\u2588\u2551\u2588\u2588\u2554\u2550\u2550\u255D     \u2588\u2588\u2551   \u000A\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2551   \u2588\u2588\u2551   \u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557\u255A\u2588\u2588\u2588\u2588\u2554\u255D \u2588\u2588\u2551  \u2588\u2588\u2551\u2588\u2588\u2551 \u255A\u2550\u255D \u2588\u2588\u2551\u2588\u2588\u2588\u2588\u2588\u2588\u2588\u2557   \u2588\u2588\u2551   \u000A\u255A\u2550\u2550\u2550\u2550\u2550\u2550\u255D   \u255A\u2550\u255D   \u255A\u2550\u2550\u2550\u2550\u2550\u2550\u255D \u255A\u2550\u2550\u2550\u255D  \u255A\u2550\u255D  \u255A\u2550\u255D\u255A\u2550\u255D     \u255A\u2550\u255D\u255A\u2550\u2550\u2550\u2550\u2550\u2550\u255D   \u255A\u2550\u255D  ", "font-family:monospace;color:#ec7d00;font-size:12px;");

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#EC7D00",
    },
    green: {
      main: Color.green[500],
    },
    red: {
      main: Color.red[500],
    },
  },
});

const styles = (theme) => ({
  "@global": {
    body: {
      margin: 0,
      backgroundImage: "url(" + ImagePath.background + ")",
      backgroundSize: "470px 1010px",
      backgroundRepeat: "repeat",
    },
  },
  cgContainer: {
    borderRadius: 25,
    overflowY: "scroll",
  },
  pdfContainer: {
    marginTop: "1.5%",
    background: "white",
    borderRadius: 20,
    paddingBottom: "1.5%",
    paddingTop: "2.5%",
    paddingRight: "2.5%",
    width: "fit-content",
    maxWidth: "100vw",
    margin: "auto",
  },
  pdfDocument: {
    width: "fit-content",
    margin: "auto",
    height: "80vh",
    overflowY: "scroll",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "row",
    margin: "20px 20px 20px 3%",
  },
  boutonSauvegarder: {
    width: "min-content",
    background: "rgb(238, 141, 31)",
    margin: "0 0 0 auto",
  },
});

/**
 * Page principale de l'application qui fait le routage pour la navigation
 */
export class App extends React.Component {
  constructor(props) {
    super(props);
  }

  state = {
    displayCG: false,
    currentCG: {},
    numPages: 1,
    aAccepte: false,
  };

  checkConditionsGenerales() {
    axiosGet(`${API_BASE_URL}/conditions_generales/current_cg`).then((resp) => {
      if (
        this.props.user &&
        resp.data.data[0][0] &&
        this.props.user.id_conditions_generales !==
          resp.data.data[0][0].id_conditions_generales
      ) {
        this.setState({
          ...this.state,
          displayCG: true,
          currentCG: resp.data.data[0][0],
        });
      }
    });
  }

  onAcceptCG() {
    axiosPost(`${API_BASE_URL}/users/${this.props.user.id_user}/accept_cg`, {
      id_conditions_generales: this.state.currentCG.id_conditions_generales,
    }).then(() => {
      this.setState({
        ...this.state,
        displayCG: false,
      });
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.user !== null && prevProps.user !== null && !prevProps.loggedIn && this.props.loggedIn) {
      // When we are logged in, refresh the auth token periodically
      this.startPeriodicRefresh();
      this.checkConditionsGenerales();
    } else if (prevProps.loggedIn && !this.props.loggedIn) {
      // Stop refreshing when we log out
      this.stopPeriodicRefresh();
    }
  }

  componentWillUnmount() {
    this.stopPeriodicRefresh();
  }

  startPeriodicRefresh() {
    this.refreshInterval = setInterval(
      () => this.props.dispatch(refreshToken()),
      60 * 60 * 1000 // One hour
    );
  }

  stopPeriodicRefresh() {
    if (!this.refreshInterval) {
      return;
    }

    clearInterval(this.refreshInterval);
  }

  render() {
    let { displayCG, currentCG } = this.state;
    const { classes, t, lng } = this.props;
    //Si l'utilisateur est null, donc public, pas de CG
    if(this.props.user === null){displayCG = false;}
    return (
      <MuiThemeProvider theme={theme}>
        <div className="App">
          <HeaderBar />
          {displayCG ? (
            <>
              <Paper elevation={3} className={classes.pdfContainer}>
                <style>
                  {
                    ".react-pdf__message--error { display: none } .react-pdf__Page__canvas { max-width: 100vw }"
                  }
                </style>
                <Document
                  key={"ICI"}
                  file={`${API_BASE_URL}/uploads/conditions_generales/${
                    currentCG.uuid
                  }/CGV_${lng.toLowerCase()}.pdf`}
                  className={classes.pdfDocument}
                >
                  {Array.from(new Array(10), (el, index) => (
                    <Page
                      scale={1.5}
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                    />
                  ))}
                </Document>
                <div className={classes.buttonContainer}>
                  <FormControlLabel
                    id={"accepter"}
                    name={"accepter"}
                    onChange={() => {
                      this.setState({
                        ...this.state,
                        aAccepte: !this.state.aAccepte,
                      });
                    }}
                    checked={this.state.aAccepte}
                    control={<Checkbox value="remember" color="primary" />}
                    label={t("cgv.message_accepter")}
                  />

                  <Button
                    onClick={this.onAcceptCG.bind(this)}
                    type="submit"
                    disabled={!this.state.aAccepte}
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.boutonSauvegarder}
                  >
                    {t("cgv.sauvegarder")}
                  </Button>
                </div>
              </Paper>
            </>
          ) : (
            <Suspense fallback={<div>Loading...</div>}>
              <Route exact path="/" render={(props) => <Menu {...props}/>} />
              <Route path="/login" render={(props) => <Login {...props}/>}/>
              <Route path="/register" render={(props) => <RegistrationPage {...props}/>} />
              <Route path="/profile" render={(props) => <Dashboard {...props}/>} />
              <Route exact path="/hammering" render={(props) => <Hammering {...props}/>} />
              <Route exact path="/measurement" render={(props) => <MeasurementTable {...props}/>} />
              <Route exact path="/lot" render={(props) => <Lot {...props}/>} />
              <Route path="/data_manager" render={(props) => <DataManager {...props}/>} />
              <Route path="/companies" render={(props) => <CompanyTable {...props}/>} />
              <Route path="/printing" render={(props) => <Printing {...props}/>} />
              <Route path="/map" render={(props) => <LotsMap {...props}/>}/>
              <Route path="/hammering/:id" render={(props) => <HammeringDetail {...props}/>}/>
              <Route path="/measurement/:id" render={(props) => <MeasurementDetail {...props}/>}/>
              <Route path="/lot/:id" render={(props) => <LotDetail {...props}/>}/>
              <Route path="/lot_of_sale/:id" render={(props) => <LofOfSaleDetail {...props}/>}/>
              <Route path="/parameters" render={(props) => <Parameters {...props}/>}/>
              <Route path="/export" render={(props) => <ExportPage {...props}/>}/>
              <Route path="/print/hammering/:id" render={(props) => <HammeringPrint {...props}/>}/>
              <Route path="/print/lot/:id" render={(props) => <LotPrint {...props}/>}/>
              <Route
                path="/print/measurement/:id/essence"
                render={(props) => <MeasurementEssencePrint {...props}/>}
              />
              <Route
                path="/print/measurement/:id/utilisation"
                render={(props) => <MeasurementUtilisationPrint {...props}/>}
              />
              <Route path="/ext/:id_lot/:token" render={(props) => <PublicDataPage {...props}/>}/>
              <Route path="/ext/print/:id_lot/:token" render={(props) => <PublicLotPrint {...props}/>}/>
            </Suspense>
          )}
        </div>
        <ToastContainer />
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  hasAuthToken: state.auth.authToken !== null,
  loggedIn: state.auth.app_user !== null,
  user: state.auth.app_user,
});

// Deal with update blocking - https://reacttraining.com/react-router/web/guides/dealing-with-update-blocking
export default withNamespaces()(
  withRouter(connect(mapStateToProps)(withStyles(styles)(App)))
);
